<h2 align="center" mat-dialog-title>Delete Form</h2>
<mat-dialog-content>Are you sure you want to delete this form?</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="close()">No</button>

  <button mat-button [mat-dialog-close]="true" (click)="deleteForm()">Yes</button>
</mat-dialog-actions>